import { BoxProps, PaletteColor, useTheme } from "@mui/material";
import { Text } from "../../core-ui/components/Text/Text";
import { TextStyleVariant } from "../../core-ui/components/Text/TextUtils";
import { ColoredSpan } from "./styles";

interface FeaturedReleasePillProps {
  text?: string;
  color?: PaletteColor;
  sx?: BoxProps["sx"];
}

export const FeatureReleasePill = ({
  text = "Featured release",
  color,
  sx,
}: FeaturedReleasePillProps) => {
  const theme = useTheme();
  const spanColor = color?.main || theme.palette.active.main;
  const textColor = color?.contrastText || theme.palette.active.contrastText;

  return (
    <ColoredSpan $backgroundColor={spanColor} sx={sx}>
      <Text
        style={{
          color: textColor,
          textAlign: "center",
          width: "100%",
        }}
        bold
        variant={TextStyleVariant.P3}
      >
        {text}
      </Text>
    </ColoredSpan>
  );
};
